import { useEffect, useState } from 'react';
import axios from "axios";
import ReactDOMServer from 'react-dom/server';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../routing/helpers/router';
import useIsMounted from '../../../../components/hooks/useIsMounted';
import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';

const Report24Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    handleOnSave,
    values,
    selectedReport,
  } = props;
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 24,
        selectedReport,
      })
      .then((r) => {
        if (isMounted.current) {
          setReportOptions(r.data);
        }
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  if (!reportOptions) return <></>;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <AppMultiSelect
            options={reportOptions?.categoryGroups || []}
            onChange={(e) => handleOnSetFieldValue('catGroups', e)}
            title={
              <Translator file="module-intelligence" name="category.groups" />
            }
            icon={<AppRemixIcon icon="apps" />}
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="select.an.option" />
            )}
            value={values.catGroups || []}
            isLoading={!reportOptions?.categoryGroups}
            isMulti
            hasSearchBox
            hasSelectOptions
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-12">
              <BtnOptions
                isDisabled={!values.catGroups}
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report24Options;
